import React from "react";
import KpiServices from "./KPIServices";
import WhyChooseBizwit from "./WhyChooseBizwit";
import HeroSection from "./GetStarted";

const ConsumerInsights = () => {
  return (
    <>
      <section className="bg-blue-50 p-8">
        <div className=" flex flex-col items-center gap-8">
          <div className="flex flex-col md:flex-row items-start gap-8 w-full">
            <div className="md:w-1/2">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
                Consumer Insights & KPIs Reporting
              </h2>
              <p className="text-lg text-gray-600 font-semibold mt-2">
                Data-Driven Consumer Insights to Empower Your Business Decisions
              </p>
              <p className="mt-4">
                In a fast-changing market landscape, understanding consumer
                behavior is more critical than ever. Leveraging consumer
                insights through key performance indicators (KPIs) helps
                businesses make informed decisions, drive innovation, and stay
                ahead of the competition.
              </p>
            </div>
            <div className="md:w-1/4">
              <img
                src="/images/consumer.png"
                alt="Consumer Insights Dashboard"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full">
            <p className="">
              Our Consumer Insights: KPIs Reporting service provides businesses
              with actionable data that highlights consumer preferences, market
              trends, and performance metrics. Whether you're tracking the
              success of a product or gauging consumer satisfaction, our KPIs
              reporting offers the clarity you need to optimize your strategies.
            </p>
            <button className="mt-6 px-6 py-3 bg-gray-800 text-white rounded-md shadow-md hover:bg-gray-700 transition">
              Unlock Actionable Insights Now
            </button>
          </div>
        </div>
      </section>
      <KpiServices />
      <WhyChooseBizwit />
      {/* <HeroSection /> */}
    </>
  );
};

export default ConsumerInsights;
